// src/App.js (example excerpt)
import React, { useState } from "react";
import fasting from "./screens/fasting";
import anxiety from "./screens/anxiety";
import sleep from "./screens/sleep";
import addiction from "./screens/addiction";
import MemoryFoodScreen from "./screens/MemoryFoodScreen"; // your main component that currently uses SENSATIONS etc.

const CATEGORIES = [fasting, anxiety, sleep, addiction];

export default function App() {
  const [categoryKey, setCategoryKey] = useState(fasting.KEY);

  const selected = CATEGORIES.find(c => c.KEY === categoryKey);

  return (
    <>
      {/* <nav className="p-3 d-flex gap-2">
        {CATEGORIES.map(c => (
          <button
            key={c.KEY}
            className={c.KEY === categoryKey ? "btn btn-dark" : "btn btn-outline-dark"}
            onClick={() => setCategoryKey(c.KEY)}
          >
            {c.TITLE}
          </button>
        ))}
      </nav> */}

      <div style={{ padding: 5 }}>
        <MemoryFoodScreen
          category={selected}
        />
      </div>
    </>
  );
}
